import styled from '@emotion/styled'
import {rhythm} from '../../lib/typography'

export default styled.h2`
  text-align: left;
  margin-top: ${rhythm(2)};
  margin-bottom: ${rhythm(1)};
  font-weight: 900;
  line-height: 1.1;
`
